<template>
  <section class="actuSection">
    <p>Blog</p>
    <h2 class="titlePage">
      <strong>_</strong> Nos Actualités
      <strong>_</strong>
    </h2>

    <Pagination nbritemsbypage="12">
      <div class="artContainer">
        <article v-for="item in $store.state.gbbuArticles" :key="item.idA">
          <router-link :to="`actualites/${item.idA}`">
            <img
              :src="buildImgUrl(item.idA, item.pictureThumbA)"
              alt="actualité gite en lebé"
              style="object-position: top"
            />
            <p>
              <span>{{ returnDate( item.datePublicationA) }}</span>
              <br />
              <strong
                v-html="splitExtrait( item.titleA, item.titleSubA)"
                style="font-weight: normal"
              ></strong>
            </p>
          </router-link>
        </article>
      </div>
    </Pagination>
  </section>
</template>

<script>
import Pagination from "@/components/Pagination.vue";

export default {
  data() {
    return {
      urlImage:
        "https://cdn-gbbu02.graphibox.eu/pub/" +
        this.$store.state.globalData.siteId +
        "/medias/articles/",
    };
  },
  components: {
    Pagination,
  },

  mounted() {},
  watch: {},

  methods: {
    buildImgUrl(id, img) {
      return this.urlImage + id + "/" + img;
    },
    returnDate(date) {
      let a = new Date(date);
      const month = a.toLocaleString("default", { month: "long" });
      return a.getDay() + " " + month + " " + a.getFullYear();
    },
    splitExtrait(title, description) {
      let val = title + "<br/>" + description;
      if (val.length > 140) {
        val = val.substring(0, 140) + "...";
      }
      return val;
    },
  },
};
</script>


<style>
.artContainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 2rem 5%;
}
.artContainer article {
  margin-bottom: 1rem;
}

.actuSection h2 {
  /* font-size: rem; */
}
</style>